import { createContext } from 'react';

export const GenreContext = createContext();


